import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { FormGroup, Button, ControlLabel, FormControl } from 'react-bootstrap';
import axios from 'axios';
import { default as config } from '../../../constants/constants';
import { firebase } from '../../../firebase';
import ControlledCheckbox from '../../../components/ControlledCheckbox';
import Toast from '../../../components/Toast';
import {
	fetchPlaylists,
	updatePlaylistDataAfterFetch
} from '../../../redux/actions/app-actions';

class CreatePlaylistModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			playlists: [],
			selectedPlaylists: [],
			playlistsToDeleteFrom: [],
			error: null,
			addPlaylist: false
		};
	}

	componentDidMount() {
		if (firebase.auth.currentUser) {
			firebase.auth.currentUser.getIdToken().then((token) => {
				fetchPlaylists(token)
					.then((res) => {
						const { data } = res;
						this.props.dispatch(updatePlaylistDataAfterFetch(res));
						this.setState({ playlists: data });
					})
					.catch((err) => this.setErrorHandler(err.response));
			});
		}
	}

	componentWillUnmount() {
		clearTimeout(this.interval);
	}

	setErrorHandler = (err) => {
		this.setState({ error: err });
		this.interval = setTimeout(() => {
			if (this.state.error) this.setState({ error: null });
		}, 3000);
	};

	fetchPlaylists = (token) => {
		const options = {
			method: 'GET',
			headers: { 'X-Firebase-Auth': token },
			url: `${config.serverURL}/playlists/?includeAll=true`
		};
		return new Promise((resolve, reject) => {
			axios(options)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject({ err });
				});
		});
	};

	onCloseHandler = () => {
		this.setState({
			selectedPlaylists: [],
			playlistsToDeleteFrom: []
		});
		this.props.onClose();
	};

	onChangeHandler = (playlist, checked) => {
		const includesInPlaylist = this.playlistContainsDocument(playlist);
		if (!includesInPlaylist) {
			if (!checked) {
				this.setState({
					selectedPlaylists: [...this.state.selectedPlaylists, playlist]
				});
			} else {
				this.setState({
					selectedPlaylists: this.state.selectedPlaylists.filter(
						(p) => p.id !== playlist.id
					)
				});
			}
		} else {
			if (!checked) {
				this.setState({
					playlistsToDeleteFrom: this.state.playlistsToDeleteFrom.filter(
						(p) => p.id !== playlist.id
					)
				});
			} else {
				this.setState({
					playlistsToDeleteFrom: [...this.state.playlistsToDeleteFrom, playlist]
				});
			}
		}
	};

	savePlaylistsHandler = () => {
		if (
			this.state.selectedPlaylists.length === 0 &&
			this.state.playlistsToDeleteFrom.length === 0 &&
			(this.newPlaylist === undefined || this.newPlaylist === null)
		) {
			this.setErrorHandler("You haven't changed anything.");
			return;
		}
		if (
			this.props.documentoAdd.url === null ||
			this.props.documentoAdd.url === ''
		) {
			this.setErrorHandler('This document is unavailable.');
			return;
		}
		if (this.newPlaylist?.value?.trim() === '') {
			this.setErrorHandler('The playlist name cannot be empty.');
			return;
		}
		if (this.newPlaylist !== undefined && this.newPlaylist !== null) {
			let userPlaylists = this.state.playlists;
			let array = userPlaylists.filter(
				(playlist) => playlist.name === this.newPlaylist.value
			);
			if (array.length > 0) {
				this.setErrorHandler(
					`A playlist with name ${this.newPlaylist.value} already exists.`
				);
				return;
			}
		}
		if (firebase.auth.currentUser) {
			firebase.auth.currentUser.getIdToken().then((token) => {
				if (
					this.state.selectedPlaylists.length > 0 ||
					(this.newPlaylist !== undefined && this.newPlaylist !== null)
				) {
					const playlists = this.state.selectedPlaylists.map((p) => p.name);

					if(this.newPlaylist != null) {
						playlists.push(this.newPlaylist.value);
					}

					const data = {
						playlistNames: playlists,
						...this.props.documentoAdd
					};
					const options = {
						method: 'POST',
						headers: { 'X-Firebase-Auth': token },
						url: `${config.serverURL}/playlists/`,
						data
					};
					axios(options)
						.then(() => {
							this.sendData();
							this.onCloseHandler();
						})
						.catch((err) => {
							this.setErrorHandler(err.response.data);
						});
				}
				if (this.state.playlistsToDeleteFrom.length > 0) {
					const playlists = this.state.playlistsToDeleteFrom.map((p) => p.name);
					const promises = [];
					playlists.forEach((playlistName) => {
						const options = {
							method: 'DELETE',
							headers: { 'X-Firebase-Auth': token },
							url: `${config.serverURL}/playlists/?playlistName=${encodeURIComponent(
								playlistName
							)}&documentName=${encodeURIComponent(
								this.props.documentoAdd.documentName
							)}&podcastId=${encodeURIComponent(
								this.props.documentoAdd.podcastId
							)}`
						};
						promises.push(axios(options));
					});
					Promise.all(promises)
						.then(() => this.onCloseHandler())
						.catch((err) => this.setErrorHandler(err.response.data));
				}
			});
		}
	};

	playlistContainsDocument = (playlist) => {
		if (this.props.documentoAdd) {
			const { documentName } = this.props.documentoAdd;
			if (playlist.playlistDocuments) {
				return playlist.playlistDocuments.some(
					(e) => e.document.documentName === documentName
				);
			}
			return false;
		}
		return false;
	};

	sendData = () => {
		this.props.parentCallback();
	};

	render() {
		const { show, title } = this.props;
		const { playlists, error } = this.state;
		return (
			<>
				{error && (
					<Toast
						type="danger"
						error={error}
						handleDismiss={() => this.setErrorHandler(null)}
					/>
				)}
				<Modal
					className="playlist-modal"
					show={show}
					onHide={this.onCloseHandler}
					backdrop={false}
				>
					<Modal.Header closeButton>
						<Modal.Title>{title}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<FormGroup controlId="tags" style={{ marginBottom: 20 }}>
							<ControlLabel className="tagsLabel">New Playlist</ControlLabel>
							<Button
								className={`$${
									this.state.addPlaylist
										? 'addPlaylist buttonAdd'
										: 'addPlaylist'
								}`}
								title="Add new playlist"
								onClick={() =>
									this.setState({ addPlaylist: !this.state.addPlaylist })
								}
							>
								+
							</Button>
							{this.state.addPlaylist ? (
								<FormControl
									type="text"
									style={{ width: '200px' }}
									inputRef={(el) => (this.newPlaylist = el)}
								/>
							) : null}
						</FormGroup>
						<FormGroup controlId="formBasicText">
							<ControlLabel className="tagsLabel">
								Existing Playlists
							</ControlLabel>
							<div className="playlists-wrapper">
								{playlists.map((playlist) => {
									const isChecked = this.playlistContainsDocument(playlist);
									return (
										<ControlledCheckbox
											key={playlist.id}
											label={playlist.name}
											change={this.onChangeHandler.bind(this, playlist)}
											isChecked={isChecked}
										>
											{playlist.name}
										</ControlledCheckbox>
									);
								})}
							</div>
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between'
								}}
							>
								<button
									onClick={this.savePlaylistsHandler}
									className="save-create-playlist"
								>
									<i
										className="fa fa-check"
										style={{
											color: '#E31690',
											marginRight: '5px'
										}}
									></i>
									Save
								</button>
								<Button onClick={this.onCloseHandler}>Cancel</Button>
							</div>
						</FormGroup>
					</Modal.Body>
				</Modal>
			</>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		playlists: store.app.playlists
	};
};

export default connect(mapStateToProps)(CreatePlaylistModal);
